import { render, staticRenderFns } from "./DepositSuccessModal.vue?vue&type=template&id=c6c2b040&scoped=true"
import script from "./DepositSuccessModal.vue?vue&type=script&lang=js"
export * from "./DepositSuccessModal.vue?vue&type=script&lang=js"
import style0 from "./DepositSuccessModal.vue?vue&type=style&index=0&id=c6c2b040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c2b040",
  null
  
)

export default component.exports